import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import * as styles from './SlidesContainer.css';
import { Slide } from './parts/Slide';
import { Gap } from '../Gap';
import { mergeStyles } from '@cian/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SlidesContainer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var slideWidth = props.slideWidth,
    gapWidth = props.gapWidth,
    slides = props.slides,
    leftOffset = props.leftOffset,
    handleSlideClick = props.handleSlideClick;
  return /*#__PURE__*/_jsx("div", {
    className: styles['carousel-slides-container'],
    "data-testid": "SlidesContainer",
    children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['carousel-slides-wrapper'])), {}, {
      style: {
        transform: "translateX(".concat(leftOffset, "px)")
      },
      ref: ref,
      children: slides.map(function (slide) {
        return /*#__PURE__*/_jsxs("div", {
          className: styles['slide-wrapper'],
          children: [/*#__PURE__*/_jsx(Gap, {
            width: gapWidth
          }), /*#__PURE__*/_jsx(Slide, {
            width: slideWidth,
            slide: slide.node,
            onClick: handleSlideClick ? function (e) {
              return handleSlideClick(Number(slide.key) - 1, e);
            } : undefined
          })]
        }, slide.key);
      })
    }))
  });
});
SlidesContainer.displayName = 'SlidesContainer';